var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 17.501,
    viewBox: "0 0 17.5 17.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_83263",
    d: "M-806.667-243v-7.63h-7.25a.75.75,0,0,1-.75-.751.75.75,0,0,1,.75-.75h7.25V-259a.75.75,0,0,1,.75-.751.75.75,0,0,1,.75.751v6.869h7.25a.75.75,0,0,1,.75.75.75.75,0,0,1-.75.751h-7.25V-243a.75.75,0,0,1-.75.751A.75.75,0,0,1-806.667-243Z",
    transform: "translate(814.667 259.752)",
    fill: "#636974"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus_icon.330c7cd03bfddb4b38247c6e42b48110.svg";
export { ForwardRef as ReactComponent };